import { Button, Popconfirm } from "antd";
import moment from "moment";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";
import { useMutation } from "react-query";
import {
  deleteCustomizedOrder,
  restoreCustomizedOrder,
} from "../../actions/my-orders/services";

export default function TableRowCancelledCustomizedOrder({
  product,
  refetch,
}: any) {
  const { mutateAsync: deleteProduct, isLoading: deleteLoading } = useMutation(
    deleteCustomizedOrder,
    {
      onSuccess: () => {
        MyNotif("Product deleted successfully.", "success");
        refetch();
      },
    }
  );
  const { mutateAsync: restoreProduct, isLoading: restoreLoading } =
    useMutation(restoreCustomizedOrder, {
      onSuccess: () => {
        MyNotif("Order restored successfully.", "success");
        refetch();
      },
    });
  return (
    <tr>
      <td scope="row">
        <span className="myorder_order_name">{product.name}</span>
      </td>
      <td scope="row">
        <span>{moment(product.updated_at).format("DD/MM/YYYY")}</span>
      </td>
      <td>
        <div>
          <Popconfirm
            placement="top"
            title={"Are you sure you want to delete this order ?"}
            onConfirm={() => deleteProduct(product.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="ghost"
              size={"middle"}
              className="mr-2"
              style={{ borderRadius: "4px" }}
              icon={<DeleteOutlined style={{ color: "#00468c" }} />}
              loading={deleteLoading}
            >
              Delete
            </Button>
          </Popconfirm>
          <Popconfirm
            placement="top"
            title={"Are you sure you want to restore this order ?"}
            onConfirm={() => restoreProduct(product.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              size={"middle"}
              style={{ borderRadius: "4px" }}
              icon={
                <InboxOutlined
                  style={{ color: "#00468c", verticalAlign: "1px" }}
                />
              }
              loading={restoreLoading}
            >
              Restore
            </Button>
          </Popconfirm>
        </div>
      </td>
    </tr>
  );
}
